
<button mat-icon-button class="close" tabindex="-1"  (click)="close()" *ngIf="!generatingLetters">x</button>
<button mat-icon-button class="audit" tabindex="-1" (click)="openAuditForForm()"><fa-icon [icon]="faHistory"></fa-icon></button>
<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">Estate Agent Details</h2>

<mat-dialog-content class="mat-typography">
  <form [formGroup]="estateAgentDetails" autocomplete="off">

    <app-card-label label="Financial Advisor/Estate Agent Name">
        <mat-form-field floatLabel="never">
          <mat-select  formControlName="addedByUserId" (selectionChange)="updateField()" [disabled]="!authService.isPortalManager() && !authService.isPortalAdmin()" >
            <mat-option *ngFor="let user of faUsers" [value]="user.id">{{user.firstName}} {{user.lastName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </app-card-label>

      <div class="itemRow">
          <label class="labelItem">Estate Agent Company</label>
          <label class="itemString">{{estateAgentDetails.controls['userCompanyName'].value}}</label>
        </div>


    <app-card-label label="Estate Agent Contact Number">
      <mat-form-field floatLabel="never">
        <input matInput formControlName="contactNumber" (change)="updateField()" >
      </mat-form-field>
    </app-card-label>

    <div class="itemRow">
        <label class="labelItem">Estate Agent Email Address</label>
        <label class="itemString">{{estateAgentDetails.controls['addedByUser'].value?.emailAddress}}</label>
      </div>

    <app-card-label label="Estate Agent Fee">
      <mat-form-field floatLabel="never">
          <span matPrefix>£ &nbsp;</span>
        <input matInput formControlName="estateAgentFee" (change)="updateField()" type="number" >
      </mat-form-field>
    </app-card-label>

    <app-card-label label="Estate Agent Postcode">
      <mat-form-field floatLabel="never">
        <input matInput #estateAgentPostcode maxlength="10" formControlName="estateAgentPostcode"
          (change)="updateField()">
        <app-address-lookup-button matSuffix [for]="addressLookup1"></app-address-lookup-button>
      </mat-form-field>
    </app-card-label>
    
    <app-address-lookup #addressLookup1 lookupType="postcode" [searchField]="estateAgentPostcode" [add1]="estateAgentDetails.controls['estateAgentAddressLine1']"
      [add2]="estateAgentDetails.controls['estateAgentAddressLine2']" [add3]="estateAgentDetails.controls['estateAgentAddressLine3']" [add4]="estateAgentDetails.controls['estateAgentAddressLine4']"
      [add5]="estateAgentDetails.controls['estateAgentAddressLine5']" [addPc]="estateAgentDetails.controls['estateAgentPostcode']" (change)="updateField();">
    </app-address-lookup>
    
    <app-card-label label="Estate Agent Address Line 1">
      <mat-form-field floatLabel="never">
        <input matInput #estateAgentAddressLine1  maxlength="100"
          formControlName="estateAgentAddressLine1" (change)="updateField()">
      </mat-form-field>
    </app-card-label>
    
    <app-card-label label="Estate Agent Address Line 2">
      <mat-form-field floatLabel="never">
        <input matInput #estateAgentAddressLine2 maxlength="100"
          formControlName="estateAgentAddressLine2" (change)="updateField()">
      </mat-form-field>
    </app-card-label>
    
    <app-card-label label="Estate Agent Address Line 3">
      <mat-form-field floatLabel="never">
        <input matInput #estateAgentAddressLine3 maxlength="100"
          formControlName="estateAgentAddressLine3" (change)="updateField()">
      </mat-form-field>
    </app-card-label>
    
    <app-card-label label="Estate Agent Address Line 4">
      <mat-form-field floatLabel="never">
        <input matInput #estateAgentAddressLine4 maxlength="100"
          formControlName="estateAgentAddressLine4" (change)="updateField()">
      </mat-form-field>
    </app-card-label>
    
    <app-card-label label="Estate Agent Address Line 5">
      <mat-form-field floatLabel="never">
        <input matInput #estateAgentAddressLine5 maxlength="100"
          formControlName="estateAgentAddressLine5" (change)="updateField()">
      </mat-form-field>
    </app-card-label>
    

  </form>

</mat-dialog-content>

<div mat-dialog-actions align="end">
    <button *ngIf="!generatingLetters" mat-stroked-button (click)="createLetters()" color="primary">Create Draft Contract Documents</button>
    <button *ngIf="generatingLetters" mat-icon-button disabled color="primary" class="right" >
        <mat-icon>
            <mat-spinner color="primary" diameter="20">
            </mat-spinner>
        </mat-icon>
      </button>
</div>

